// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__zvz5q","tooltip-icon":"Icon_tooltip-icon__cdfpu"};